import PropTypes from 'prop-types'
import { Textarea, SIZE } from 'baseui/textarea'
import { mergeOverrides } from 'baseui'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { SDTextareaPulseOverrides } from './styled-components'

const SDTextarea = ({ error, missing = false, overrides, ...rest }) => {
  const isPulse = usePulseScope()
  if (rest.hidden) return null
  const newOverrides = isPulse ? mergeOverrides(SDTextareaPulseOverrides(error, missing), overrides ?? {}) : overrides

  return <Textarea size={rest.size ?? SIZE.compact} error={error} overrides={newOverrides} {...rest} />
}

SDTextarea.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  missing: PropTypes.bool,
  overrides: PropTypes.object,
}

export default SDTextarea
